/**
 * Xenia fox mascot logo component.
 * Renders the cartoon fox illustration at the requested size.
 */
export default function FoxLogo({ size = 32, className = "", "data-testid": testId = "fox-logo" }) {
  return (
    <img
      src="/fox-logo.png"
      alt="Xenia fox mascot"
      width={size}
      height={size}
      data-testid={testId}
      className={`inline-block object-contain ${className}`}
      style={{ borderRadius: "0" }}
    />
  );
}
